import { axiosAjax } from '@app/src/config/axios';
import { AnnouncementDetailModel } from '@app/src/views/MyAccount/listAvailable/models/AnnouncementDetailModel';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const serviceAnnouncementDetail = {
  async get(categoryId: number, uniqueId: string): Promise<AnnouncementDetailModel> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_ANNOUNCEMENT_DETAIL
        .replace(':categoryId', String(categoryId))
        .replace(':uniqueId', uniqueId),
        config
      );
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
